import styled from 'styled-components';

export const HelperText = styled.p`
  padding-top: 4px;
  font-size: 12.8px;
  color: var(--offer1-green);
`;
